<template>
  <operator-form />
</template>

<script>
import OperatorForm from '@/components/forms/OperatorForm'
export default {
  components: {
    OperatorForm
  }
}
</script>
